import { ScrollingModule } from '@angular/cdk/scrolling';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatListModule } from '@angular/material/list';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatTooltipModule } from '@angular/material/tooltip';
import { CollabConflictResolutionDialogModule } from '@portal-core/collab/components/collab-conflict-resolution-dialog/collab-conflict-resolution-dialog.module';
import { FormControlErrorMessageModule } from '@portal-core/forms/components/form-control-error-message/form-control-error-message.module';
import { ErrorsExpansionPanelModule } from '@portal-core/general/components/errors-expansion-panel/errors-expansion-panel.module';
import { LoaderModule } from '@portal-core/general/components/loader/loader.module';
import { SelfTruncatingPathModule } from '@portal-core/general/components/self-truncating-path/self-truncating-path.module';
import { PluralizeModule } from '@portal-core/general/pipes/pluralize/pluralize.module';
import { ProjectFilePathInputModule } from '@portal-core/project-files/components/project-file-path-input/project-file-path-input.module';
import { PathListItemModule } from '@portal-core/ui/list/components/path-list-item/path-list-item.module';
import { McColorModule } from '@portal-core/ui/themes/directives/mc-color.module';
import { WorkspaceFilesUserStatusListModule } from '@portal-core/workspaces/components/workspace-files-user-status-list/workspace-files-user-status-list.module';
import { CollabCommitDialogComponent } from './collab-commit-dialog.component';

@NgModule({
  declarations: [
    CollabCommitDialogComponent
  ],
  imports: [
    McColorModule,
    CollabConflictResolutionDialogModule,
    CommonModule,
    ErrorsExpansionPanelModule,
    FormsModule,
    FormControlErrorMessageModule,
    LoaderModule,
    SelfTruncatingPathModule,
    MatButtonModule,
    MatDialogModule,
    MatExpansionModule,
    MatFormFieldModule,
    MatIconModule,
    MatInputModule,
    MatListModule,
    MatToolbarModule,
    MatTooltipModule,
    PathListItemModule,
    PluralizeModule,
    ProjectFilePathInputModule,
    ReactiveFormsModule,
    ScrollingModule,
    WorkspaceFilesUserStatusListModule
  ],
  exports: [
    CollabCommitDialogComponent
  ]
})
export class CollabCommitDialogModule { }
